import React from "react";
import {LogoDinersIcon} from "../../../../../../../assets/svg/logo-diners.icon";
import {CardNetworkModel} from "./card-network.model";
import {CardNetworksEnum} from "../../payment-method-codes.enum";
import {ICardNetworkIconOptions} from "./card-network.view-model.interface";

export class DinersCardNetworkModel extends CardNetworkModel {

    constructor() {
        super(CardNetworksEnum.Diners);
    }

    get name(): string {
        return "Diners Club";
    }

    renderIcon(options?: ICardNetworkIconOptions): React.ReactElement | null {
        return (<LogoDinersIcon {...options}/>);
    }
}